import styled from "styled-components";

export const TitleSection = styled.section`
  width: 82vw;
  min-height: calc(100vh - 100px);
  display: flex;
  justify-content: space-between;

  .title-container {
    margin-left: -45px;
    h1 {
      /* max-width: 500px; */
      /* width: 700px; */
      margin-top: 10vh;
      color: #333;
      font-size: 40px;
      font-weight: 400;
      position: relative;
      opacity: 1;

    }
    h6 {
      max-width: 300px;
      font-size: 24px;
      font-weight: 500;
      // font-family: serif;
      color: #666;
      position: relative;
      opacity: 1;
      margin-left: 60px;
    }
  }

  .img-container {
    width: 50%;
    display: flex;
    justify-content: center;
    position: relative;
    a {
      margin-top: calc(10vh + 325px);
      margin-right: 60px;
      font-size: 24px;
      font-family: serif;
      text-decoration: underline;
      text-decoration-thickness: 2px;
      color: #55f;
      height: 30px;
    }
    .profile-img {
      margin-top: 10vh;
      max-height: 350px;
      opacity: 1;
      position: relative;

      -webkit-filter: blur(0);
      filter: blur(0);
      -webkit-transition: .3s ease-in-out;
      transition: .3s ease-in-out;
    }

    .tran {
      filter: blur(4px);
      -webkit-filter: blur(4px);
    }

  }
`;
